<div class="list-container">
  <h1 class="text-2xl font-bold mb-4">{{ 'USERS.LIST.TITLE' | translate }}</h1>

  @if (error) {
    <app-alert [type]="'danger'">{{ error }}</app-alert>
  }

  <app-button color="primary" [rounded]="'full'" (click)="createNewUser()">
<!--    <i data-feather="plus" class="h-4 w-4 me-3"></i>-->
    {{ 'USERS.LIST.CREATE' | translate }}
  </app-button>

  <!-- Loading indicator for initial load -->
  @if (paginationState().loading) {
    <div class="mb-4">
      <app-loading size="large" color="primary" />
    </div>
  }

  @if (!paginationState().loading && users.length > 0) {
    <div class="overflow-x-auto mt-2">
      <table class="table-auto w-full border-collapse border border-slate-400">
        <thead>
        <tr class="bg-neutral-100 dark:bg-neutral-700">
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'USERS.LIST.ID' | translate }}</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'USERS.LIST.EMAIL' | translate }}</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'USERS.LIST.USERNAME' | translate }}</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'USERS.LIST.GROUP_NAME' | translate }}</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2"></th>
        </tr>
        </thead>
        <tbody>
          @for (user of users; track user.id; let even = $even) {
            <tr [ngClass]="even ? 'bg-neutral-50 dark:bg-neutral-800' : 'bg-white dark:bg-neutral-900'">
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ user.id }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ user.email }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ user.userName }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ user.groupName || 'USERS.LIST.GROUP_NONE' | translate }}</td>
              <td class="border border-neutral-300 dark:border-neutral-600 p-2">
                <a class="flex items-center justify-center underline" [routerLink]="['/users/edit', user.id]">
                  <i class="h-4 w-4 me-3 text-base mr-1 border-white" [innerHTML]="'eye' | feather: { width: 16, height: 16 }"></i>
                </a>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="8">{{ 'PAGINATION.NO_ITEMS' | translate }}</td>
            </tr>
          }
        </tbody>
      </table>

      <app-pagination [paginationState]="paginationState()" [onPaginationChange]="onPageChange"></app-pagination>
    </div>
  }
</div>
